import EventsListingRenderer from "../utils/Events/listing/Renderer";

document.addEventListener('DOMContentLoaded', () => {
  EventsListingRenderer.renderEventsApp('cjs-events-listing');
})